
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersNight as ObiHeavySleetShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-night.js';
 
 
 

 
 export const ObiHeavySleetShowersNight = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-night',
   elementClass: ObiHeavySleetShowersNightElement,
   events: {
     
   }
  });
 
 